import React, { useEffect } from 'react';
import styles from './Modal.module.scss';

interface ModalProps {
  img: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ img, onClose }) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={styles.modalContent}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        <img src={img} alt="Document" className={styles.modalImage} />
        <button type="button" className={styles.closeButton} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;

